const styles = theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#F4F6F8',
    borderRadius: '8px',
    padding: '0px 16px',
    height: '56px',
  },

  textField: {
    width: '66px',
    backgroundColor: '#fff',
    borderRadius: '6px',
  },
  heading: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#002E47',
  },
})

export default styles
